import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGripVertical, faTrash } from '@fortawesome/pro-solid-svg-icons';

import { useDrag, useDrop } from 'react-dnd';

import { Button } from 'components/ui/button';
import { getSelectOptions } from 'bundles/apex/pipeline/settings/helpers';
import ManagedFormGroup from 'components/form/managed_input/form_group';

const DRAG_TYPE = 'PIPELINE_COLUMN';

export default function CustomColumn({
  allOptions,
  availableOptions,
  columnIndex,
  value,
  onChange,
  onDelete,
  onReorder,
}) {
  const ref = useRef(null);
  const dragRef = useRef(null);

  const [{ isDragging }, drag, preview] = useDrag({
    collect: monitor => ({ isDragging: monitor.isDragging() }),
    item: { value },
    type: DRAG_TYPE,
  });

  const [, drop] = useDrop({
    accept: DRAG_TYPE,
    hover(draggedItem) {
      if (draggedItem.value !== value) onReorder?.(draggedItem.value, value);
    },
  });

  preview(drop(ref));
  drag(dragRef);

  return (
    <div className="d-flex align-items-center gap-2" ref={ref} style={{ opacity: isDragging ? 0 : 1 }}>
      <div ref={dragRef} style={{ cursor: 'grab' }}>
        <FontAwesomeIcon className="text-muted" icon={faGripVertical}/>
      </div>
      <ManagedFormGroup
        label={null}
        name={`column-${columnIndex}`}
        type="select"
        value={value}
        onValueChange={value => onChange(columnIndex, value)}
      >
        {getSelectOptions(allOptions, availableOptions, value).map(
          ({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ),
        )}
      </ManagedFormGroup>
      <Button icon={faTrash} tooltip="Delete Column" variant="ghost" onClick={onDelete} />
    </div>
  );
}

CustomColumn.propTypes = {
  allOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  availableOptions: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ).isRequired,
  columnIndex: PropTypes.number.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
};
